import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard';
import { Alert } from '../components/Alert';
import { api } from '../lib/api';

/**
 * Confirmation de la récupération MFA (« téléphone perdu »).
 *
 * La désactivation exige un CLIC explicite : le lien de l'e-mail ne fait
 * qu'amener ici. Un simple GET qui désactiverait le second facteur serait
 * exécuté par les scanners de liens des messageries avant même que
 * l'utilisateur ouvre le message.
 */
export function MfaResetPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [state, setState] = useState<'idle' | 'pending' | 'done' | 'error'>('idle');

  async function confirm() {
    setState('pending');
    try {
      await api.post('/auth/mfa/recovery/confirm', { token });
      setState('done');
    } catch {
      setState('error');
    }
  }

  if (!token) {
    return (
      <AuthCard title="Lien invalide">
        <Alert message="Ce lien de récupération est incomplet." />
        <Link className="btn btn-secondary" to="/login">
          Retour à la connexion
        </Link>
      </AuthCard>
    );
  }

  if (state === 'done') {
    return (
      <AuthCard title="Double authentification désactivée">
        <Alert
          message="Vous pouvez vous reconnecter avec votre mot de passe seul. Toutes vos sessions ont été fermées."
          variant="success"
        />
        <p className="subtitle">
          Pensez à réactiver la double authentification depuis les réglages de sécurité de
          SEmplyApp dès que possible.
        </p>
        <Link className="btn" to="/login">
          Se connecter
        </Link>
      </AuthCard>
    );
  }

  return (
    <AuthCard
      title="Désactiver la double authentification ?"
      subtitle="Votre compte redeviendra accessible avec votre mot de passe seul — un niveau de protection en moins, jusqu'à réactivation."
    >
      {state === 'error' ? (
        <Alert message="Ce lien est invalide, expiré, ou a déjà servi. Refaites une demande depuis l'écran de connexion." />
      ) : null}
      <button className="btn" type="button" disabled={state === 'pending'} onClick={() => void confirm()}>
        {state === 'pending' ? 'Désactivation…' : 'Oui, désactiver'}
      </button>
      <Link className="btn btn-secondary" style={{ marginTop: '0.5rem' }} to="/login">
        Annuler
      </Link>
    </AuthCard>
  );
}
